import { Fragment } from 'react';

import { cn } from '@Blocks/_components/ui/utils';

import type { MenuType } from '@/_types/Shared/SiteDatas';
import { Link } from '@inertiajs/react';

import { MenuChildIcon } from '../../Icons';

export default function Menu({
	menu,
	itemClass,
	variantMenuChildItems,
	addSeparation,
}: {
	menu: MenuType[] | undefined;
	itemClass: any;
	variantMenuChildItems: string | undefined;
	addSeparation: boolean;
}) {
	const topLink = itemClass.menuItems;
	const subLink = itemClass.childMenuItems + ' whitespace-nowrap';

	const childClass =
		"before:content-[''] before:w-full before:h-0.5 before:block before:bg-minos-header-topnav-icon-color before:mb-3.5";

	let gapItemChild = 'gap-5';

	if (variantMenuChildItems === 'separation') {
		gapItemChild = 'gap-3.5';
	}

	const mobileSeparation =
		"w-full text-center first:before:hidden desktop::before:hidden before:content-[''] before:w-full before:h-0.5 before:block before:bg-minos-header-topnav-icon-color before:mb-8";

	return (
		<div className='w-full py-5 desktop:w-auto'>
			<ul className='flex flex-col items-center gap-8 desktop:flex-row desktop:items-baseline'>
				{menu?.map((item: MenuType) => {
					return (
						<Fragment key={item.id}>
							{item.children && typeof item.children != 'string' && item.children.length > 0 ? (
								<li
									className={`group relative flex flex-wrap items-center justify-center gap-2 ${addSeparation ? mobileSeparation : ''} ${variantMenuChildItems === 'arrow' ? 'py-1.5' : ''}`}
								>
									<CustomLink item={item} classes={topLink} />
									<MenuChildIcon
										className={cn(
											'inline-bloc rotate-0 transition-all group-hover:rotate-180',
											itemClass.iconColor
										)}
									/>
									<ul
										className={cn(
											'w-full desktop:w-auto invisible relative desktop:absolute top-full left-1/2 z-40 -translate-x-1/2 p-4 flex flex-col items-center group-hover:visible group-focus-within:visible',
											gapItemChild,
											itemClass.menuChildBg,
											itemClass.menuChildRadius
										)}
									>
										{variantMenuChildItems === 'arrow' && (
											<div className='absolute -top-1.5 left-1/2 z-40 -translate-x-1/2'>
												<svg
													width='10'
													height='7'
													viewBox='0 0 9 6'
													xmlns='http://www.w3.org/2000/svg'
													className={itemClass.menuChildSvg}
												>
													<path
														fillRule='evenodd'
														clipRule='evenodd'
														d='M4.48186 0.585693L8.96373 5.58569H0L4.48186 0.585693Z'
													/>
												</svg>
											</div>
										)}
										{item.children.map((child: MenuType, index: number) => {
											return (
												<li
													key={child.id}
													className={`group-focus-within:visible group-hover:visible ${variantMenuChildItems === 'separation' && index > 0 ? childClass : ''}`}
												>
													<CustomLink item={child} classes={subLink} />
												</li>
											);
										})}
									</ul>
								</li>
							) : (
								<li
									key={item.id}
									className={`group relative ${addSeparation ? mobileSeparation : ''} ${variantMenuChildItems === 'arrow' ? 'py-1.5' : ''}`}
								>
									<CustomLink item={item} classes={topLink} />
								</li>
							)}
						</Fragment>
					);
				})}
			</ul>
		</div>
	);
}

const CustomLink = ({ item, classes }: { item: MenuType; classes: string }) => {
	return (
		<>
			{item.type === 'custom' ? (
				<a href={item.url} className={classes}>
					{item.title}
				</a>
			) : (
				<Link href={item.url} className={classes}>
					{item.title}
				</Link>
			)}
		</>
	);
};
